// extracted by mini-css-extract-plugin
module.exports = {"skeletonCredentialLine":"DocuSignCredentialsSkeleton_skeletonCredentialLine__2j4w2"};